import axios from "@/plugins/axios";

let url = "/api/v1/boards/settings";

export default {
    get(data) {
        return axios.get(url, data).then((result) => result.data);
    }
};
